/**
 * Creates an LRU cache backed by a Map.
 * Map preserves insertion order — delete+set moves an entry to the end (most recent).
 * @util
 *
 * @__NO_SIDE_EFFECTS__
 */
export function createLruCache(options) {
    const { maxSize } = options;
    const cache = options.cache ?? new Map();
    return {
        get,
        set,
        has,
        delete: deleteKey,
        clear,
        values: () => cache.values(),
        keys: () => cache.keys(),
        get size() {
            return cache.size;
        },
        cache,
    };
    function get(key) {
        if (!cache.has(key)) {
            return undefined;
        }
        const value = cache.get(key);
        // Move to most recent by re-inserting
        cache.delete(key);
        cache.set(key, value);
        return value;
    }
    function set(key, value) {
        // If key already exists, delete first to update insertion order
        cache.delete(key);
        if (cache.size >= maxSize) {
            // Evict the oldest (first) entry — iterate keys() to handle
            // cases where `undefined` itself is a valid key.
            for (const oldest of cache.keys()) {
                cache.delete(oldest);
                break;
            }
        }
        cache.set(key, value);
    }
    function has(key) {
        return cache.has(key);
    }
    function deleteKey(key) {
        return cache.delete(key);
    }
    function clear() {
        cache.clear();
    }
}
//# sourceMappingURL=createLruCache.js.map